import api from "./api";

export const searchAddresses = (query, options) =>
  api.get({
    path: "/locations",
    query,
    options,
  });
